<template>
  <div class="container mx-auto flex flex-col laptop:flex-row py-12 laptop:mt-150px">
    <div :class="imageBoxAlignmentClass" class="w-full flex laptop:w-1/2 p-5 md:p-0 md:px-8">
      <slot name="image" />
    </div>
    <div :class="textBoxAlignmentClass" class="w-full flex laptop:w-1/2 laptop:ml-24 p-5 laptop:px-12 md:p-0 md:px-8 flex-col laptop:justify-around">
      <div>
        <slot name="text" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  name: 'Box',
  props: {
    textAlignment: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    imageBoxAlignmentClass() {
      return this.textAlignment === 'left' ? 'order-last laptop:order-last' : 'order-last laptop:order-first'
    },
    textBoxAlignmentClass() {
      return this.textAlignment === 'left' ? 'order-first laptop:order-first' : 'order-first laptop:order-last'
    }
  }
})
</script>
<style scoped>
</style>
